import * as Yup from "yup";
import i18n from "../i18n";

export const SMSConfigSchema = Yup.object({
  VisitSubmitToVisitor: Yup.string().required(
    i18n.language === "en"
      ? "Visit Submit To Visitor SMS Template is required"
      : "إرسال الزيارة للزائر قالب رسالة نصية مطلوب"
  ),
  VisitApproval: Yup.string().required(
    i18n.language === "en"
      ? "Visit Approval SMS Template is required"
      : "الموافقة على الزيارة قالب رسالة نصية مطلوب"
  ),
  VisitApprovedScheduledToVisitor: Yup.string().required(
    i18n.language === "en"
      ? "Visit Approved Scheduled To Visitor SMS Template is required"
      : "إشعار الزيارة المجدولة المعتمدة للزائر قالب رسالة نصية مطلوب"
  ),
  VisitApprovedScheduledToHost: Yup.string().required(
    i18n.language === "en"
      ? "Visit Approved Scheduled To Host SMS Template is required"
      : "إشعار الزيارة المجدولة المعتمدة للمضيف قالب رسالة نصية مطلوب"
  ),
  VisitRejectedToVisitor: Yup.string().required(
    i18n.language === "en"
      ? "Visit Rejected To Visitor SMS Template is required"
      : "إشعار رفض الزيارة للزائر قالب رسالة نصية مطلوب"
  ),
  VisitRejectedToHost: Yup.string().required(
    i18n.language === "en"
      ? "Visit Rejected To Host SMS Template is required"
      : "إشعار رفض الزيارة للمضيف قالب رسالة نصية مطلوب"
  ),
  ExternalCancelToVisitor: Yup.string().required(
    i18n.language === "en"
      ? "External Cancel To Visitor SMS Template is required"
      : "إشعار الإلغاء الخارجي للزائر قالب رسالة نصية مطلوب"
  ),
  ExternalCancelToHost: Yup.string().required(
    i18n.language === "en"
      ? "External Cancel To Host SMS Template is required"
      : "إشعار الإلغاء الخارجي للمضيف قالب رسالة نصية مطلوب"
  ),
  HostCancelToVisitor: Yup.string().required(
    i18n.language === "en"
      ? "Host Cancel To Visitor SMS Template is required"
      : "إشعار إلغاء المضيف للزائر قالب رسالة نصية مطلوب"
  ),
  HostCancelToHost: Yup.string().required(
    i18n.language === "en"
      ? "Host Cancel To Host SMS Template is required"
      : "إشعار إلغاء المضيف للمضيف قالب رسالة نصية مطلوب"
  ),
  DevicesRejectedToVisitor: Yup.string().required(
    i18n.language === "en"
      ? "Devices Rejected To Visitor SMS Template is required"
      : "إشعار رفض الأجهزة للزائر قالب رسالة نصية مطلوب"
  ),
  DevicesRejectedToHost: Yup.string().required(
    i18n.language === "en"
      ? "Devices Rejected To Host SMS Template is required"
      : "إشعار رفض الأجهزة للمضيف قالب رسالة نصية مطلوب"
  ),
  ExternalPasswordReset: Yup.string().required(
    i18n.language === "en"
      ? "External Password Reset SMS Template is required"
      : "إعادة تعيين كلمة المرور الخارجية قالب رسالة نصية مطلوب"
  ),
  ExternalRegistration: Yup.string().required(
    i18n.language === "en"
      ? "External Registration SMS Template is required"
      : "التسجيل الخارجي قالب رسالة نصية مطلوب"
  ),
  CheckIn: Yup.string().required(
    i18n.language === "en"
      ? "Check In SMS Template is required"
      : "تسجيل الدخول قالب رسالة نصية مطلوب"
  ),
  CheckOut: Yup.string().required(
    i18n.language === "en"
      ? "Check Out SMS Template is required"
      : "تسجيل الخروج قالب رسالة نصية مطلوب"
  ),
  OTP: Yup.string().required(
    i18n.language === "en"
      ? "OTP SMS Template is required"
      : "كلمة المرور لمرة واحدة قالب رسالة نصية مطلوب"
  ),
  DirectStaffApprovalToSecurityUsers: Yup.string().required(
    i18n.language === "en"
      ? "Direct Staff Approval To Security Users SMS Template is required"
      : "الموافقة المباشرة للموظفين لمستخدمي الأمن قالب رسالة نصية مطلوب"
  ),
  DirectStaffApprovalToSecurityManagers: Yup.string().required(
    i18n.language === "en"
      ? "Direct Staff Approval To Security Managers SMS Template is required"
      : "الموافقة المباشرة للموظفين لمديري الأمن قالب رسالة نصية مطلوب"
  ),
  DirectStaffRejectionToSecurityUsers: Yup.string().required(
    i18n.language === "en"
      ? "Direct Staff Rejection To Security Users SMS Template is required"
      : "رفض الموظفين المباشر لمستخدمي الأمن قالب رسالة نصية مطلوب"
  ),
  DirectStaffRejectionToSecurityManagers: Yup.string().required(
    i18n.language === "en"
      ? "Direct Staff Rejection To Security Managers SMS Template is required"
      : "رفض الموظفين المباشر لمديري الأمن قالب رسالة نصية مطلوب"
  ),
  Evacuation: Yup.string().required(
    i18n.language === "en"
      ? "Evacuation SMS Template is required"
      : "الإخلاء قالب رسالة نصية مطلوب"
  ),
  // PermitApproved: Yup.string().required(
  //   i18n.language === "en"
  //     ? "Permit Approved SMS Template is required"
  //     : "الموافقة على التصريح قالب رسالة نصية مطلوب"
  // ),
  testSms: Yup.string().matches(
    /^(?:\+\d{8,15}|[0-9]\d{8,15})$/,
    i18n.language === "en" ? "Enter a valid number." : "أدخل رقمًا صالحًا."
  ),
});
